import e from "react";
// src/design/forms/datepicker/core/models/context.tsx
var t = e.createContext(null);
export { t as StoreContext };

//# sourceMappingURL=context.js.map